import * as React from "react";
const SvgSignalLoading = (props) => (React.createElement("svg", Object.assign({ viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m6.781 7.719-2.607 2.607-2.61 2.61 2.61 2.609 2.607 2.61.532-.532.53-.531-2.08-2.078-2.077-2.078 2.078-2.079 2.08-2.078-.532-.531Zm10.436 0-.53.529-.53.531 2.077 2.078 2.078 2.079-2.078 2.078-2.078 2.078.532.531.529.531 2.61-2.61 2.609-2.608-2.61-2.61zM7.498 11.95V13.92h1.967V11.95H8.48zm3.514 0V13.92h1.976V11.95H12Zm3.521 0V13.92H16.502V11.95h-.984z", style: {
            clipRule: "evenodd",
            fill: "currentColor",
            fillRule: "evenodd",
        } })));
export default SvgSignalLoading;
